import { blue, grey } from '../../../common/styles/colours';
export var CheckboxStylePropertiesByVariant = {
    default: function (theme) {
        var _a, _b, _c, _d, _e, _f;
        return ({
            color: (_a = theme.contentOnColor) !== null && _a !== void 0 ? _a : grey[0],
            borderColor: (_b = theme.borderSecondary) !== null && _b !== void 0 ? _b : grey[400],
            checkedBorderColor: 'transparent',
            indeterminateBorderColor: 'transparent',
            backgroundColor: (_c = theme.backgroundUI) !== null && _c !== void 0 ? _c : grey[0],
            checkedBackgroundColor: (_d = theme.backgroundAccentPrimary) !== null && _d !== void 0 ? _d : blue[600],
            indeterminateBackgroundColor: (_e = theme.backgroundAccentPrimary) !== null && _e !== void 0 ? _e : blue[600],
            disabledBackgroundColor: (_f = theme.contentAccessory) !== null && _f !== void 0 ? _f : grey[500],
        });
    },
};
//# sourceMappingURL=CheckboxStylePropertiesByVariant.js.map